export default __webpack_public_path__ + "static/media/logo.5d9a15f9.svg";